import {ChannelLogo, HStack} from "@hosttools/frontend";
import {type AccountCustom} from "@hosttools/frontend/models/account";
import type React from "react";
import {memo} from "react";

import Paragraph from "@/client/components/Paragraph";

interface Props {
    account: AccountCustom;
}

const Header: React.FC<Props> = ({account}) => {
    return (
        <HStack className="items-center" space="sm">
            <ChannelLogo channel={account.type} size="md" />
            <Paragraph color="blueGray.800" variant="sm">
                {account.username ?? "-"}
            </Paragraph>
        </HStack>
    );
};

export default memo(Header);
